import React, { useState, useEffect, useRef } from 'react';

function StatsSection() {
  const [counts, setCounts] = useState({
    projects: 0,
    clients: 0,
    awards: 0
  });
  const [hasAnimated, setHasAnimated] = useState(false);
  const sectionRef = useRef(null);

  const stats = [
    {
      icon: 'fa fa-check',
      value: 6000,
      label: 'Project Complete',
      key: 'projects'
    },
    {
      icon: 'fa fa-smile-o',
      value: 10000,
      label: 'Happy Client',
      key: 'clients'
    },
    {
      icon: 'fa fa-trophy',
      value: 250,
      label: 'Awards Won',
      key: 'awards'
    },
  ];

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting && !hasAnimated) {
            setHasAnimated(true);
            animateCounters();
          }
        });
      },
      { threshold: 0.5 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => {
      if (sectionRef.current) {
        observer.unobserve(sectionRef.current);
      }
    };
  }, [hasAnimated]);

  const animateCounters = () => {
    const duration = 2000; // 2 seconds
    const steps = 60;
    const stepDuration = duration / steps;

    let currentStep = 0;

    const interval = setInterval(() => {
      currentStep++;
      const progress = currentStep / steps;

      setCounts({
        projects: Math.floor(6000 * progress),
        clients: Math.floor(10000 * progress),
        awards: Math.floor(250 * progress)
      });

      if (currentStep >= steps) {
        clearInterval(interval);
        setCounts({
          projects: 6000,
          clients: 10000,
          awards: 250
        });
      }
    }, stepDuration);
  };

  const getDisplayValue = (key) => {
    const value = counts[key];
    return value >= 1000 ? `${Math.floor(value / 1000)}${value % 1000 === 0 ? '000' : value % 1000}+` : `${value}+`;
  };

  return (
    <section className="stats-section" ref={sectionRef}>
      <div className="container stats-container">
        {stats.map((stat, idx) => (
          <div className="stat-card" key={idx}>
            <div className="stat-icon"><i className={stat.icon} /></div>
            <div className="stat-info">
              <div className="stat-value">{getDisplayValue(stat.key)}</div>
              <div className="stat-label">{stat.label}</div>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}

export default StatsSection; 